import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { imageUrl } from '../lib/images';

export default function OmOsPage() {
  const bookingUrl = 'https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a';
  const [practitioners, setPractitioners] = useState(null);

  useEffect(() => {
    fetch('/_api/public/v2/content/behandlere?sort=sortering&order=asc')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.items && data.items.length > 0) {
          setPractitioners(data.items);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <SEOHead
        title="Mød Behandlerne | Djurs Massage"
        description="Lær teamet bag Djurs Massage at kende. Tine Thorsen, indehaver med over 24 års erfaring, RAB-zoneterapeut Sophie og kosmetolog Dianna i Ryomgård."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/tine-vium-thorsen-fysiurgisk-massaor.png"
      />

      {/* Clean page header - NO container box, NO paragraph above heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Mød behandlerne hos Djurs Massage
          </h1>
          <p className="text-slate-700 text-sm sm:text-base mt-3 leading-relaxed font-normal">
            Hos Djurs Massage brænder vi for at skabe mærkbar smertelindring, øget bevægelighed og dyb kropslig ro. Klinikken er en del af det private hjem på Poppelvej i Ryomgård, hvilket afspejles i rolige, trygge og hyggelige omgivelser med en nærværende, personlig atmosfære.
          </p>
        </div>
      </div>

      {/* Practitioners Detailed Profiles - Directly on page without card boxes */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 divide-y divide-[#E8E1D5]">
        {practitioners && practitioners.length > 0 ? (
          practitioners.map((p, idx) => {
            const isEven = idx % 2 === 1;
            const photoUrl = p.billede?.[0] || 'https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/tine-vium-thorsen-fysiurgisk-massaor.png';
            return (
              <section key={p.id || idx} className="py-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
                <div className={`lg:col-span-5 ${isEven ? 'lg:order-last' : ''} aspect-4/5 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]`}>
                  <img
                    src={imageUrl(photoUrl, 'width=600,height=750,fit=cover,quality=90,format=auto')}
                    alt={p.navn ? `${p.navn} - ${p.titel || 'Behandler hos Djurs Massage'}` : 'Behandler hos Djurs Massage'}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="lg:col-span-7 space-y-4">
                  <h2 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] font-serif">
                    {p.navn}
                  </h2>

                  <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed [&>p]:leading-relaxed [&>p]:mt-2">
                    {p.beskrivelse ? (
                      <div dangerouslySetInnerHTML={{ __html: p.beskrivelse }} />
                    ) : (
                      <p>{p.kort_beskrivelse}</p>
                    )}
                  </div>

                  <div className="pt-3 flex flex-wrap items-center gap-3">
                    <a
                      href={p.booking_url || bookingUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
                    >
                      <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                      <span>{p.booking_tekst || `Book tid hos ${p.navn}`}</span>
                    </a>
                    {p.laes_mere_link && (
                      <Link
                        to={p.laes_mere_link}
                        className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1E3A5F] hover:text-black transition-colors"
                      >
                        <span>Læs mere →</span>
                      </Link>
                    )}
                  </div>
                </div>
              </section>
            );
          })
        ) : (
          <>
            {/* Tine Thorsen, indehaver */}
            <section className="py-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-5 aspect-4/5 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
                <img
                  src={imageUrl('https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/tine-vium-thorsen-fysiurgisk-massaor.png', 'width=600,height=750,fit=cover,quality=90,format=auto')}
                  alt="Tine Thorsen, indehaver - Grundlægger af Djurs Massage"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="lg:col-span-7 space-y-4">
                <div className="flex flex-wrap items-center gap-3">
                  <h2 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] font-serif">
                    Tine Thorsen, indehaver
                  </h2>
                  <span className="text-xs font-bold text-[#1E3A5F] bg-[#1E3A5F]/10 px-2.5 py-1 rounded-full">
                    RAB-godkendt massør
                  </span>
                </div>

                <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                  <p>
                    Min første uddannelse er fra 2001, og jeg har siden da opbygget en bred vifte af uddannelser inden for både fysiurgisk massage og mange andre specialiserede kropsteknikker.
                  </p>
                  <p>
                    Jeg er <strong>RAB-godkendt</strong> (Registreret Alternativ Behandler), hvilket er <strong>det eneste officielle kvalitetsstempel</strong> for massører i Danmark og sundhedsforsikringernes krav for at dække massage.
                  </p>
                  <p>
                    Fysiurgisk massage hos mig er godkendt ved <strong>Falck Healthcare</strong>, som netop har meddelt, at massage også dækkes ved <strong>AP Pensions sundhedsforsikring</strong>.
                  </p>
                  <p>
                    Jeg startede Djurs Massage for over 24 år siden og fandt hurtigt ud af, at jeg virkelig kunne gøre en mærkbar forskel for mine klienter. Gennem mine mange års erfaring har jeg opbygget en solid forståelse af, hvordan kroppen hænger sammen – herunder hvordan det at løsne muskler og sener fjerner spændingstrækket i leddene og dermed skaber forbedret mobilitet og markant smertelindring.
                  </p>
                  <p className="text-xs italic text-slate-600">
                    * Bemærk venligst, at der ikke anvendes engangsmaterialer. Klienter skal fortsat have eget lagen og håndklæde med til alle behandlinger.
                  </p>
                </div>

                <div className="pt-3 flex flex-wrap items-center gap-3">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
                  >
                    <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                    <span>Book fysiurgisk massage hos Tine</span>
                  </a>
                  <Link
                    to="/behandlinger#fysiurgisk-massage"
                    className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1E3A5F] hover:text-black transition-colors"
                  >
                    <span>Læs om fysiurgisk massage →</span>
                  </Link>
                </div>
              </div>
            </section>

            {/* Sophie Hebsgaard Ede */}
            <section className="py-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-5 lg:order-last aspect-4/5 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
                <img
                  src="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/1000004057.jpg"
                  alt="Sophie Hebsgaard Ede - Zoneterapeut hos Djurs Massage"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="lg:col-span-7 space-y-4">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] font-serif">
                  Sophie Hebsgaard Ede
                </h2>

                <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                  <p>
                    Sophie er 36 år og bor i Ryomgård med mand og 2 børn.
                  </p>
                  <p>
                    Jeg er zoneterapeut og tager udgangspunkt i hver enkelt klient med fokus på reflekszonebehandling. Jeg udfører desuden også nænsom zoneterapi til babyer.
                  </p>
                  <p>
                    Jeg er RAB godkendt, hvilket betyder, at du kan få tilskud gennem Sygeforsikring Danmark, samt flere forskellige private sundhedsforsikringer.
                  </p>
                  <p>
                    Kontakt din private sundhedsforsikring og forhør dig om dækning til zoneterapi.
                  </p>
                </div>

                <div className="pt-3 flex flex-wrap items-center gap-3">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
                  >
                    <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                    <span>Book zoneterapi hos Sophie</span>
                  </a>
                  <Link
                    to="/behandlinger#zoneterapi"
                    className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1E3A5F] hover:text-black transition-colors"
                  >
                    <span>Læs om zoneterapi →</span>
                  </Link>
                </div>
              </div>
            </section>

            {/* Dianna */}
            <section className="py-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-5 aspect-4/5 overflow-hidden border border-[#E8E1D5] bg-[#E8E1D5]">
                <img
                  src={imageUrl('/_assets/portrait-dianna-kosmetolog.jpg', 'width=600,height=750,fit=cover,quality=90,format=auto')}
                  alt="Dianna - Kosmetolog hos Djurs Massage"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="lg:col-span-7 space-y-4">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1E3A5F] font-serif">
                  Dianna
                </h2>

                <div className="space-y-3 text-slate-700 text-sm sm:text-base leading-relaxed">
                  <p>
                    Dianna er uddannet kosmetolog i Spanien og varetager klinikkens kosmetologiske behandlinger med særlig grundighed og omhu.
                  </p>
                  <p>
                    Hendes primære fokus er på professionel og skånsom voksbehandling, beroligende relax massage til ryg, nakke eller hele kroppen, samt kosmetologisk pedicure og fodbehandling.
                  </p>
                  <p>
                    Dianna lægger vægt på, at du føler dig fuldstændig tryg og afslappet i klinikkens hyggelige og behagelige omgivelser.
                  </p>
                </div>

                <div className="pt-3 flex flex-wrap items-center gap-3">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 sm:px-6 sm:py-2.5 bg-[#1E3A5F] text-white text-xs sm:text-sm font-semibold rounded-full hover:shadow-md transition-shadow"
                  >
                    <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                    <span>Book behandling hos Dianna</span>
                  </a>
                  <Link
                    to="/behandlinger#relax-massage"
                    className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1E3A5F] hover:text-black transition-colors"
                  >
                    <span>Læs om relax massage →</span>
                  </Link>
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </>
  );
}
